import { Reveal } from "../../lib/motion";
import { CHOICES } from "../../lib/siteData";

export const WhatRemains = () => {
  return (
    <section id="what-remains" data-testid="what-remains-section" className="relative py-28 lg:py-40 bg-es-surface">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
          <Reveal className="lg:col-span-6">
            <p className="text-[11px] uppercase tracking-[0.4em] text-es-accent mb-6">
              A governed continuum
            </p>
            <h2 className="font-serif font-light text-es-fg tracking-tight leading-[1.02] text-[clamp(2rem,5vw,4rem)]">
              You decide what remains.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5 lg:col-start-8 self-end">
            <p className="text-es-muted-fg leading-relaxed">
              EverSoul is not based on a single form of digital continuation. Each person
              determines what may be preserved, who may receive it, and whether any
              interactive representation may exist.
            </p>
          </Reveal>
        </div>

        <div data-testid="choices-continuum" className="relative border-t border-es-border">
          {CHOICES.map((c, i) => (
            <Reveal
              key={c.k}
              delay={i * 0.06}
              className="group border-b border-es-border"
            >
              <div className="grid lg:grid-cols-12 gap-4 lg:gap-8 items-baseline py-8 lg:py-10">
                <div className="lg:col-span-1 flex items-center gap-3">
                  <span className="text-[11px] tracking-[0.35em] text-es-muted-fg">
                    {`0${i + 1}`}
                  </span>
                </div>
                <div className="lg:col-span-4 flex items-center gap-4">
                  <span
                    className="h-1.5 w-1.5 rounded-full bg-es-accent transition-transform duration-500 group-hover:scale-150"
                    style={{ opacity: 0.4 + i * 0.12 }}
                    aria-hidden
                  />
                  <h3 className="font-serif font-light text-es-fg text-[clamp(1.6rem,3.2vw,2.6rem)] tracking-tight">
                    {c.k}
                  </h3>
                </div>
                <p className="lg:col-span-7 text-es-muted-fg leading-relaxed max-w-xl">
                  {c.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-14 font-serif italic text-es-fg text-xl sm:text-2xl tracking-tight">
            Continuation is never assumed. It is chosen.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
